import * as React from 'react'
import { Box, Typography } from '@mui/material'
import { formatPercentage } from "@ui-seeker/utils"

import { NotAllowedBlock } from '@components'


export default function shareColumn(name, label) {
	return {
		name: name, label: label,
		options: {
			filter: false,
			customBodyRowRenderLite: (value) => <Box sx={{ textAlign: 'center' }}>
				{!!value && <Typography>{formatPercentage(value, { decimals: 2 })}</Typography>}
				{!value && <NotAllowedBlock />}
			</Box>
		}
	}
}